import React from 'react';

const SvgIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59.53 30.26"
  >
    <circle
      cx="19.11"
      cy="25.47"
      r="3.61"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <polyline
      points="43.1 8.7 48.89 8.7 54.71 14.1 54.71 25.68 52.28 25.68"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <circle
      cx="48.68"
      cy="25.54"
      r="3.61"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <polyline
      points="46.99 8.7 46.99 15.04 54.71 15.04"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M21.63,17.66h-3.5l-.7-3.22c1.95-.35,3-1.43,3.51-2.18.27-.4.41-.87.41-1.35v-4.88"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M31.3,6.03v4.88c0,.48.14.95.41,1.35.51.74,1.56,1.82,3.51,2.18l-.7,3.22h-3.48"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M21.35,10.91s.13,1.15,1.21,1.71,2.7,1.25,3.64,3.01c0,0-.67,2.6-3.37,2.32,0,0-3.24,0-3.66-4.06"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M31.3,10.91s-.13,1.15-1.21,1.71-2.7,1.25-3.64,3.01c0,0,.67,2.6,3.37,2.32,0,0,3.24,0,3.66-4.06"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line
      x1="25.5"
      y1="16.93"
      x2="27.16"
      y2="16.93"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <polyline
      points="8.66 16.15 8.66 25.54 15.5 25.54"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <polyline
      points="22.71 25.47 43.1 25.47 43.1 2.38 8.66 2.38 8.66 6.34"
      fill="none"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line
      x1="43.1"
      y1="25.54"
      x2="45.07"
      y2="25.54"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line
      x1="3.99"
      y1="8.73"
      x2="11.59"
      y2="8.73"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line
      x1="1.21"
      y1="11.28"
      x2="11.59"
      y2="11.28"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <line
      x1="11.59"
      y1="13.83"
      x2="3.99"
      y2="13.83"
      stroke="#292d35"
      strokeWidth="0.93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIcon;
